// Core
import React from 'react';

import css from './style.scss';

const Footer = function() {
  return (
    <footer className={ css.Footer }>
      <p>
        <a href="mailto:hi@rughsterdesign.com" className={ css.a }>hi@rughsterdesign.com</a> | Website art by <a href="http://aaronsather.com" className={ css.a }>Aaron Sather</a>
        {/* <a href="mailto:hi@rughsterdesign.com" className={ css.a }>hi@rughsterdesign.com</a> | <a href="tel:8013869084" className={ css.tel }>801-386-9084</a> */}
      </p>
    </footer>
  )
}

export default Footer;


// WEBPACK FOOTER //
// ./app/js/components/Footer/index.js